<template>
    <el-container style="height: 100%;">
        <el-header>
            <MyHeader ></MyHeader><!--v-if="showPage"v-if="$route.meta.keepAlive" -->
        </el-header>
        <el-container style="height: calc(100% - 61px);overflow-y: auto;">
            <el-aside style="width:auto;">
                <MyAside></MyAside>
            </el-aside>
            <el-main>
                <MyTab></MyTab>
                <keep-alive :include="cachedViews">
                    <router-view ></router-view>
                </keep-alive>
                <!--这种方式也可实现缓存<keep-alive >
                    <router-view :key="$route.path"></router-view>
                </keep-alive>-->
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import MyHeader from '@/components/MyHeader'
import MyAside from '@/components/MyAside'
import MyTab from '@/components/MyTab'
import { mapActions } from 'vuex'
//import bus from '@/utils/eventBus'
export default {
    name: 'INDEX',
    components: { MyHeader, MyAside, MyTab },
    data(){
        return {
            data: [],
            showPage: false,
            cachedViews:['']
        }
    },
    methods: {
        ...mapActions('user',['getInfo','getMenu','getCodeList'])
    },
    created() {
        // console.log('进入index，执行getInfo')
        this.getInfo(
            //(item)=>{
            // let redirect = decodeURIComponent(this.$route.query.redirect || '/main');
            // this.$router.push({ path: redirect })// 获取登录成功后要跳转的路由
            /*console.log('传递的值',item)
            console.log('原访问页内容',this.$route.query)
            if(this.$route.query.name!=undefined){
                console.log('跳转到原访问页')
                bus.$emit('share', this.$route.query)
                this.data.push(this.$route.query)
            }*//*else{
                bus.$emit('share', item)
                this.data.push(item)
            }*/
           // this.showPage=true
        //}
        )
        this.getMenu()
        this.getCodeList()
    },

}
</script>

<style lang="scss" scoped="scoped">
.el-header{
    padding: 0;
}

</style>
